module.exports = __webpack_public_path__ + "static/media/header-4.0707e818.png";